<mat-sidenav-container class="contact-list__root container" [hasBackdrop]="true">
  <mat-sidenav class="fixed" #drawer [mode]="'over'" position="start">
    <app-organizations
      [profile]="profile() || undefined"
      (logout)="onLogout()"
      (close)="drawer.toggle()"
      (selected)="onOrganizationSelected($event)"
    ></app-organizations>
  </mat-sidenav>
  <section class="contact-list__root_logo-ctn header">
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="header__content">
          <div class="left">
            <button mat-icon-button (click)="drawer.toggle()" aria-label="Menu">
              <mat-icon>menu</mat-icon>
            </button>
            <h3>{{ currentOrganization()?.description }}</h3>
          </div>
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
  </section>
  <section class="contact-list">
    <app-dashboard-section-header
      [headerText]="callbackLocationsHeaderText()"
      (addNew)="onAddCallbackLocation()"
    >
      <div class="contact-list__callback-locations white-background-content">
        @if (locationsLoading() === true) {
          <ng-container *ngTemplateOutlet="loadLocations"></ng-container>
        } @else if (locations().length > 0) {
          <mat-list class="contact-list__items contact-list__items--static">
            @for (loc of locations(); track loc.id) {
              <mat-list-item lines="2" class="contact-list__items__item contact-list__items__item--location">
                <span matListItemTitle class="title">{{ loc.name }}</span>
                <span matListItemLine class="title">{{ formatPhone(loc.phone) }}</span>
                <div matListItemMeta class="actions menu-container">
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="Callback location actions"
                    [matMenuTriggerFor]="locationMenu"
                    (click)="$event.stopPropagation()"
                  >
                    <mat-icon>more_horiz</mat-icon>
                  </button>
                  <mat-menu #locationMenu="matMenu" xPosition="before">
                    <button mat-menu-item (click)="onEditCallbackLocation(loc)">
                      <mat-icon>edit</mat-icon>
                      <span>Edit Callback Location</span>
                    </button>
                    <button mat-menu-item (click)="onDeleteCallbackLocation(loc)">
                      <mat-icon>delete</mat-icon>
                      <span>Delete Callback Location</span>
                    </button>
                  </mat-menu>
                </div>
              </mat-list-item>
            }
          </mat-list>
        } @else {
          <p class="empty-message">There are no callback locations.</p>
        }
      </div>
    </app-dashboard-section-header>

    <app-dashboard-section-header
      [headerText]="activeAlertsHeaderText()"
      [hideAddButton]="true"
    >
      <form [formGroup]="searchForm" class="contact-list__root__search-ctn">
        <mat-form-field class="search full-width" appearance="outline" subscriptSizing="dynamic">
          <input
            matInput
            #searchInput
            [placeholder]="activeAlertsSearchPlaceholder()"
            formControlName="search"
          />
          @if (searchForm.get('search')?.value) {
            <button
              mat-icon-button
              matSuffix
              type="button"
              aria-label="Clear search"
              (click)="clearSearch(searchInput)"
            >
              <mat-icon>backspace</mat-icon>
            </button>
          } @else {
            <mat-icon matSuffix class="search-suffix-icon" aria-hidden="true">search</mat-icon>
          }
        </mat-form-field>
      </form>
      @if (activeAlertsLoading() !== true) {
        @if (pagedActiveAlerts().length > 0) {
          <div class="active-alerts-table white-background-content">
            <div class="active-alerts-table__head">
              @for (col of activeAlertColumns; track col.key) {
                <button
                  type="button"
                  class="active-alerts-table__sort"
                  [class.active-alerts-table__sort--active]="activeAlertSortKey() === col.key"
                  (click)="toggleActiveAlertSort(col.key)"
                >
                  <span>{{ activeAlertColumnLabel(col) }}</span>
                  @if (activeAlertSortIcon(col.key); as icon) {
                    <mat-icon aria-hidden="true">{{ icon }}</mat-icon>
                  }
                </button>
              }
              <span class="active-alerts-table__actions-col" aria-hidden="true"></span>
              <span class="active-alerts-table__chevron-col" aria-hidden="true"></span>
            </div>
            @for (alert of pagedActiveAlerts(); track alert.id) {
              <article
                class="active-alerts-table__row"
                role="link"
                tabindex="0"
                (click)="onSelectedAlert(alert)"
                (keydown.enter)="onSelectedAlert(alert)"
              >
                <span
                  class="active-alerts-table__cell active-alerts-table__cell--datetime"
                  [attr.data-label]="'Created'"
                >
                  @if (splitDateTime(alert.initiatedOn); as dt) {
                    <span class="active-alerts-table__datetime-stack">
                      <span class="active-alerts-table__datetime-date">{{ dt.date }}</span>
                      @if (dt.time) {
                        <span class="active-alerts-table__datetime-time">{{ dt.time }}</span>
                      }
                    </span>
                  } @else {
                    —
                  }
                </span>
                <span class="active-alerts-table__cell" data-label="Campaign">{{ campaignLabel(alert) }}</span>
                <span
                  class="active-alerts-table__cell active-alerts-table__cell--datetime active-alerts-table__cell--next"
                  data-label="Next alert"
                >
                  @if (alert.nextAlertAt) {
                    <span class="active-alerts-table__datetime-stack active-alerts-table__next-stack">
                      @if (splitDateTime(alert.nextAlertAt); as dt) {
                        <span class="active-alerts-table__datetime-date">{{ dt.date }}</span>
                        @if (dt.time) {
                          <span class="active-alerts-table__datetime-time">{{ dt.time }}</span>
                        }
                      }
                      @if (nextAlertAttemptLabel(alert); as attemptLabel) {
                        <span class="active-alerts-table__accent">{{ attemptLabel }}</span>
                      }
                    </span>
                  } @else {
                    —
                  }
                </span>
                <span class="active-alerts-table__cell active-alerts-table__cell--datetime" data-label="End">
                  @if (splitDateTime(alert.scheduledEndAt); as dt) {
                    <span class="active-alerts-table__datetime-stack">
                      <span class="active-alerts-table__datetime-date">{{ dt.date }}</span>
                      @if (dt.time) {
                        <span class="active-alerts-table__datetime-time">{{ dt.time }}</span>
                      }
                    </span>
                  } @else {
                    —
                  }
                </span>
                <span class="active-alerts-table__cell" [attr.data-label]="subjectColumnLabel()">{{
                  alert.alertSubject
                }}</span>
                <span class="active-alerts-table__cell" data-label="Contact">{{
                  formatPhone(alert.contactPhone)
                }}</span>
                <span class="active-alerts-table__actions-col">
                  <div
                    class="active-alerts-table__stop"
                    role="button"
                    tabindex="0"
                    aria-label="Stop alert"
                    (click)="stopActiveAlert($event, alert)"
                    (keydown.enter)="stopActiveAlert($event, alert)"
                  >
                    <mat-icon class="active-alerts-table__stop-icon">stop_circle</mat-icon>
                    STOP
                  </div>
                </span>
                <span class="active-alerts-table__chevron-col">
                  <mat-icon aria-hidden="true">chevron_right</mat-icon>
                </span>
              </article>
            }
          </div>
          @if (hasPreviousPage() || hasNextPage()) {
            <nav class="active-alerts-table__pager" aria-label="Active alerts pagination">
              <button
                mat-stroked-button
                type="button"
                [disabled]="!hasPreviousPage()"
                (click)="onPreviousPage()"
              >
                Previous
              </button>
              <span class="active-alerts-table__pager-label">Page {{ pageIndex() + 1 }}</span>
              <button mat-stroked-button type="button" [disabled]="!hasNextPage()" (click)="onNextPage()">
                Next
              </button>
            </nav>
          }
        } @else {
          <div class="active-alerts-empty white-background-content">
            <mat-icon class="active-alerts-empty__icon" aria-hidden="true">notifications_paused</mat-icon>
            <p class="active-alerts-empty__title">No active alerts</p>
            <p class="active-alerts-empty__hint">When an alert is in progress, it will show up in this list.</p>
          </div>
        }
      } @else {
        <ng-container *ngTemplateOutlet="loadPatients"></ng-container>
      }
    </app-dashboard-section-header>
  </section>
</mat-sidenav-container>
<ng-template #loadLocations>
  <div class="loading">
    <mat-card appearance="outlined" class="place_holder">
      <mat-card-content>
        <app-skeleton
          viewBox="0 0 150 24"
          [speed]="2"
          backgroundColor="#E0DCDC"
          foregroundColor="rgba(0, 0, 0, 0.1)"
        >
          <svg:rect x="3" y="0" rx="0" ry="0" width="50%" height="9" />
          <svg:rect x="3" y="12" rx="0" ry="0" width="35%" height="9" />
        </app-skeleton>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<ng-template #loadPatients>
  <div class="loading">
    <mat-card appearance="outlined" class="place_holder">
      <mat-card-content>
        <app-skeleton
          viewBox="0 0 150 24"
          [speed]="2"
          backgroundColor="#E0DCDC"
          foregroundColor="rgba(0, 0, 0, 0.1)"
        >
          <svg:rect x="140" y="0" rx="0" ry="0" width="10px" height="9" />
          <svg:rect x="3" y="0" rx="0" ry="0" width="50%" height="9" />
          <svg:rect x="3" y="11" rx="0" ry="0" width="30%" height="9" />
        </app-skeleton>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
